import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  makeStyles,
  withStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { Colors } from '../../helpers/theme';

interface VestingSectionProps {
  pool: any;
}

const useStyles = makeStyles({
  tableRoot: {
    // minWidth: 650,
    borderRadius: "15px",
    boxShadow: "0px 8px 28px 0px #3EB8AA12, 0px 4px 6px 0px #06092505",
    border: "none",
    background: Colors.white,
  },
  button: {
    // add styles for your buttons here to match the image
    width: "120px",
    height: "37px",
    padding: "10px, 40px, 10px, 40px",
    borderRadius: "68px",
    '& span': {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "17px",
        letterSpacing: "0em"
    }
  },
  // Add other styles as needed
});


const StyledTableCell = withStyles((theme: Theme) => createStyles({
    head: {
        color: Colors.greyLight + " !important",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "none",
        "&:nth-child(1)": {
            width: "20%", // Set the width for the first column
        },
        "&:nth-child(2)": {
            width: "20%", // Set the width for the second column
        },
        "&:nth-child(3)": {
            width: "20%", // Set the width for the third column
        },
        "&:nth-child(4)": {
            width: "30%", // Set the width for the fourth column
        },
    },
    body: {
        color: Colors.greySlate + " !important",
        fontSize: "15px !important",
        fontWeight: 200,
        boxShadow: "none",
        "&:nth-child(1)": {
            width: "20%", // Set the width for the first column
        },
        "&:nth-child(2)": {
            width: "20%", // Set the width for the second column
        },
        "&:nth-child(3)": {
            width: "20%", // Set the width for the third column
        },
        "&:nth-child(4)": {
            width: "30%", // Set the width for the fourth column
        },
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      // Apply styles for all rows
      backgroundColor: Colors.white,
      borderRadius: "15px",
      margin: "10px 0px 5px 0px",
      boxShadow: "0px 8px 28px 0px #3EB8AA12, 0px 4px 6px 0px #06092505",
      '&:hover': {
        backgroundColor: Colors.secondaryWhite,
        cursor: 'pointer',
      },
    },
  }),
)(TableRow);



function VestingSection({ pool }: VestingSectionProps) {
  
  const classes = useStyles();

  const [claimStatus, setClaimStatus] = useState<string[]>([]);

  const totalTokenEarned = pool.investments?.reduce((acc: any, investment: any) => {
    return acc + investment.totalTokenEarned;
  }, 0);

  const totalTokenClaimable = pool.investments?.reduce((acc: any, investment: any) => {
    return acc + investment.totalTokenClaimable;
  }, 0);

  const totalTokenClaimed = pool.investments?.reduce((acc: any, investment: any) => {
    return acc + investment.totalTokenClaimed;
  }, 0);

  const amount = (percentage: number) => {
    let amount = '0';
    const tokensAmount = totalTokenEarned * ( percentage / 100 );
    if (pool.currentPriceUsd && pool.currentPriceUsd !== 0) {
      amount = tokensAmount + '  = $' + Number((tokensAmount * pool.currentPriceUsd).toFixed(3));
    } else {
      amount = tokensAmount.toString();
    }
    return amount;
  }

  useEffect(() => {
    const vestingArray = pool.vesting;
    const totalVestings = vestingArray.length;
    const isAirDrop = pool.distributionScAddress && pool.distributionScAddress.length > 0 && pool.distributionScAddress[0].isAirdropped
    let calculatedTokens = 0;
    const newClaimStatuses = [];

    for (let i = 0; i < totalVestings; i++) {
      const vesting = vestingArray[i];
      const vestingTokens = totalTokenEarned * (vesting.percentage / 100);

      const tokens = calculatedTokens + vestingTokens;

      if (totalTokenClaimed >= tokens) {
        newClaimStatuses.push('Claimed');
      } else if (totalTokenClaimed < tokens && tokens <= totalTokenClaimable) {
        if (isAirDrop) {
          newClaimStatuses.push('Airdropped');
        } else {
          newClaimStatuses.push('Available');
        }
      } else if (tokens > totalTokenClaimable) {
        newClaimStatuses.push('Upcoming');
      } else {
        newClaimStatuses.push('Upcoming');
      }
      calculatedTokens += vestingTokens;
    }

    setClaimStatus(newClaimStatuses);
  }, [totalTokenClaimed, totalTokenEarned, pool, totalTokenClaimable]);

 
  return (
    <TableContainer component={Paper} className={classes.tableRoot}>
      <Table aria-label="customized table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="center">Percentage</StyledTableCell>
            <StyledTableCell align="center">Amount</StyledTableCell>
            <StyledTableCell align="center">Status</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {pool.vesting?.map((row: any, index: any) => (
            <StyledTableRow key={index}>
              <StyledTableCell component="th" scope="row">
                {new Date(row.date).toLocaleString().split(',')[0]}
              </StyledTableCell>
              <StyledTableCell align="center">{row.percentage}</StyledTableCell>
              <StyledTableCell align="center">{amount(row.percentage)}</StyledTableCell>
              <StyledTableCell align="center">
                {
                  claimStatus[index] || '//'
                }
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default VestingSection;
